export const movieList = [
  {
    name: 'Garage Olimpo',
    url: 'https://ok.ru/video/3184708618903',
    img: '/static/images/garage_olimpo.jpeg',
  },
  {
    name: 'Se busca',
    url: 'https://www.youtube.com/playlist?list=PLGIP2SzAkWMZBblblHwpeduVHGNn_3Fkx',
    img: '/static/images/se_busca.jpg',
  },
  {
    name: 'La historia oficial',
    url: 'https://ok.ru/video/6909177629268',
    img: '/static/images/la_historia_oficial.webp',
  },
  {
  name: 'Infancia clandestina',
  url: 'https://ok.ru/video/5022673996312',
  img: '/static/images/infancia_clandestina.jpeg',
},
  {
    name: 'Argentina 1985',
    url: 'https://ok.ru/video/6946765540056',
    img: '/static/images/argentina_1985.webp',
  },
    {
    name: 'Pasaje de vida',
    url: 'https://play.cine.ar/INCAA/produccion/2496',
    img: '/static/images/pasaje_de_vida.jpeg',
  },
  {
    name: 'Operación México, una pacto de amor',
    url: 'https://ok.ru/video/4698434374234',
    img: '/static/images/operacion_mexico.jpeg',
  },
  {
    name: 'Televisión por la identidad',
    url: 'https://youtu.be/D3_eALxvQDA?si=U6eOOKwOoPhtvjgE',
    img: '/static/images/tv_por_la_identidad.jpg',
  },
    {
    name: 'Kamtchatka',
    url: 'https://ok.ru/video/5291381754392',
    img: '/static/images/kamtchatka.webp',
  },
    {
    name: 'Pañuelos para la historia',
    url: 'https://play.cine.ar/INCAA/produccion/7526',
    img: '/static/images/pañuelos.jpeg',
  },
  {
    name: 'La amiga',
    url: 'https://ok.ru/video/3446574156306',
    img: '/static/images/la_amiga.jpeg',
  },
  {
    name: 'El censor',
    url: 'https://ok.ru/video/3308729862886',
    img: '/static/images/el_censor.jpg',
  },
  {
    name: 'Sinfonía para Ana',
    url: 'https://ok.ru/video/1699686255257',
    img: '/static/images/sinfonia.jpeg',
  },
  {
    name: 'Andrés no quiere dormir la siesta',
    url: 'https://ok.ru/video/3848782678618',
    img: '/static/images/andres.jpeg',
  },
  {
    name: 'El premio',
    url: 'https://ok.ru/video/1333481245274',
    img: '/static/images/el_premio.jpeg',
  },
  {
    name: 'Hermanas',
    url: 'https://ok.ru/video/6466732821181',
    img: '/static/images/hermanas.jpeg',
  },
  {
    name: 'Moira',
    url: 'https://ok.ru/video/3767448832755',
    img: '/static/images/moira.jpeg',
  },
  {
    name: 'El exilio de Gardel',
    url: 'https://ok.ru/video/3416589208121',
    img: '/static/images/el_exilio_de_gardel.jpeg',
  },
  {
    name: 'Pueblo chico',
    url: 'https://ok.ru/video/5268605373097',
    img: '/static/images/pueblo_chico.jpeg',
  },
  {
    name: 'Sur',
    url: 'https://ok.ru/video/2043989920401',
    img: '/static/images/sur.jpeg',
  },
  {
    name: 'Eva y Lola',
    url: 'https://ok.ru/video/1380774120026',
    img: '/static/images/eva_y_lola.jpg',
  },
    {
    name: 'Hebe',
    url: 'https://youtu.be/3olYriodhGg?si=AxJHWDX39CyGpMG1',
    img: '/static/images/hebe.jpg',
  },
  {
    name: 'Los días de Junio',
    url: 'https://ok.ru/video/4450873051801',
    img: '/static/images/los_dias_de_junio.jpeg',
  },
  {
    name: 'Padre',
    url: 'https://www.youtube.com/watch?v=-0B-fB42zCI',
    img: '/static/images/padre.jpg',
  },
  {
    name: 'M',
    url: 'https://play.cine.ar/INCAA/produccion/759',
    img: '/static/images/m.jpeg',
  },
  {
    name: 'Sonata en sí menor',
    url: 'https://play.cine.ar/INCAA/produccion/8492',
    img: '/static/images/sonata_en_si_menor.jpeg',
  },
  {
    name: 'Bemolución',
    url: 'https://play.cine.ar/INCAA/produccion/9114',
    img: '/static/images/bemolucion.jpeg',
  },
  {
    name: 'Se va a acabar',
    url: 'https://play.cine.ar/INCAA/produccion/7710',
    img: '/static/images/se_va_a_acabar.jpeg',
  },
  {
    name: 'Que no daría yo por la memoria',
    url: 'https://play.cine.ar/INCAA/produccion/7408',
    img: '/static/images/que_no_daria_yo.jpeg',
  },
  {
    name: '70 y pico',
    url: 'https://play.cine.ar/INCAA/produccion/5467',
    img: '/static/images/70_y_pico.jpeg',
  },
    {
    name: 'ESMA, la voz de los sobrevivientes',
    url: 'https://www.youtube.com/watch?v=yTRc6l7PMVs&pp=ygUOZXNtYSBlbmN1ZW50cmSBwkJzQkBhyohjO8%3D',
    img: '/static/images/esma_2.jpg',
  },
  {
    name: 'Un muro de silencio',
    url: 'https://ok.ru/video/6470988663485',
    img: '/static/images/un_muro_de_silencio.jpeg',
  },
  {
    name: 'Los prohibidos',
    url: 'https://play.cine.ar/INCAA/produccion/7983',
    img: '/static/images/los_prohibidos.jpeg',
  },
  {
    name: 'La noche de los lápices',
    url: 'https://ok.ru/video/3379044747802',
    img: '/static/images/la_noche_de_los_lapices.jpeg',
  },
  {
    name: 'Historias cotidianas',
    url: 'https://play.cine.ar/INCAA/produccion/7983',
    img: '/static/images/historias_cotidianas.jpeg',
  },
  {
    name: 'Ivonne',
    url: 'https://play.cine.ar/INCAA/produccion/7274',
    img: '/static/images/ivonne.jpeg',
  },
  {
    name: 'La casa de Arguello',
    url: 'https://play.cine.ar/INCAA/produccion/6148',
    img: '/static/images/la_casa_de_arguello.jpeg',
  },
  {
    name: 'Jorge Novak',
    url: 'https://play.cine.ar/INCAA/produccion/8077',
    img: '/static/images/jorge_novak.jpeg',
  },
  {
    name: 'Deja la luz prendida',
    url: 'https://play.cine.ar/INCAA/produccion/5241',
    img: '/static/images/deja_la_luz_prendida.jpeg',
  },
  {
    name: 'Octubre 23: una historia de estudiantes secundarios',
    url: 'https://play.cine.ar/INCAA/produccion/8972',
    img: '/static/images/octubre_23.jpeg',
  },
  {
    name: 'La larga noche de Francisco Sanctis',
    url: 'https://play.cine.ar/INCAA/produccion/4001',
    img: '/static/images/la_larga_noche.jpeg',
  },
  {
    name: 'El secreto libre',
    url: 'https://play.cine.ar/INCAA/produccion/7587',
    img: '/static/images/el_secreto_libre.jpeg',
  },
  {
    name: 'Condenados',
    url: 'https://play.cine.ar/INCAA/produccion/8031',
    img: '/static/images/condenados.jpeg',
  },
  {
    name: 'La masacre de San Patricio',
    url: 'https://www.youtube.com/watch?v=GghHdZmWtYs',
    img: '/static/images/la_masacre_de_san_patricio.jpeg',
  },
  {
    name: 'Flores de Septiembre',
    url: 'https://www.youtube.com/watch?v=SYgo1hfwaO0&t=359s',
    img: '/static/images/flores_de_septiembre.jpeg',
  },
  {
    name: 'Ojos azules',
    url: 'https://www.youtube.com/watch?v=9JFZSssS98U',
    img: '/static/images/ojos_azules.webp',
  },
  {
    name: 'Séptimo',
    url: 'https://www.youtube.com/watch?v=pBnja2TOq3g',
    img: '/static/images/septimo.webp',
  },
  {
    name: 'El almuerzo',
    url: 'https://www.youtube.com/watch?v=LBJqxJOam1k',
    img: '/static/images/el_almuerzo.jpeg',
  },
  {
    name: 'El golpe. Memoria del horror',
    url: 'https://www.youtube.com/watch?v=9Llh2vAWWCE&pp=ygUeZG9jdW1lbnRhbCBkaWN0YWR1cmEgYXJnZW50aW5h',
    img: '/static/images/el_golpe.jpg',
  },
  {
    name: 'ESMA, la voz de los sobrevivientes',
    url: 'https://www.youtube.com/watch?v=yTRc6l7PMVs&pp=ygUeZG9jdW1lbnRhbCBkaWN0YWR1cmEgYXJnZW50aW5h',
    img: '/static/images/esma.jpg',
  },
  {
    name: 'Dictaduras latinoamericanas',
    url: 'https://www.youtube.com/watch?v=ufzoqg3lIkY&pp=ygUeZG9jdW1lbnRhbCBkaWN0YWR1cmEgYXJnZW50aW5h',
    img: '/static/images/dictaduras_latinoamericanas.jpg'
  },
  {
    name: 'Toddy',
    url: 'https://www.youtube.com/watch?v=hAI0YCC754U',
    img: '/static/images/toddy.jpeg'
  },
  {
    name: '1976',
    url: 'https://www.youtube.com/watch?v=Ap3qaI_rHL4',
    img: '/static/images/1976.jpg',
  },
  {
    name: 'Líneas de teléfono',
    url: 'https://www.youtube.com/watch?v=vuHueQNAW4I',
    img: '/static/images/lineas_de_telefono.jpeg'
  }

];
